// extracted by mini-css-extract-plugin
export default {"reportStickyHeader":"CreateReportPage_reportStickyHeader__lc7m7"};